import type { DashboardHandlers } from '@sparklayer-io/dashboard/lib/dashboard-page';
import { useRouter } from '@tanstack/react-router';
import { useMemo } from 'react';
import { apiHandler } from './api';
import { authHandler } from './auth';
import { envHandler } from './env';
import { createHostNavigationHandler, type HostNavContext } from './navigation';
import { notificationHandler } from './notification';

/** Build the `DashboardHandlers` bundle a dashboard-only page (or the site switcher) needs: the
 * host navigation handler scoped to `navContext`, plus the four stateless handlers. */
export function useDashboardHandlers(navContext: HostNavContext): DashboardHandlers {
  const router = useRouter();
  const { siteId, siteEnv, env } = navContext;

  return useMemo<DashboardHandlers>(
    () => ({
      navigationHandler: createHostNavigationHandler(router as never, { siteId, siteEnv, env }),
      authHandler,
      envHandler,
      apiHandler,
      notificationHandler,
    }),
    [router, siteId, siteEnv, env],
  );
}
